var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table" },
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "div",
            { staticClass: "handle-box" },
            [
              _c(
                "el-form",
                {
                  ref: "queryCondition",
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.queryCondition,
                    "label-position": _vm.labelPosition,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "计划月",
                                        prop: "monthList",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "multiple_sel",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            multiple: "",
                                            placeholder: "请选择(支持多选)",
                                          },
                                          model: {
                                            value: _vm.queryCondition.monthList,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "monthList",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.monthList",
                                          },
                                        },
                                        _vm._l(
                                          _vm.monthOptions,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item,
                                                value: item,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "Category2",
                                        prop: "category2CodesList",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticClass: "multiple_sel",
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            multiple: "",
                                            filterable: "",
                                            placeholder: "请选择(支持多选)",
                                          },
                                          model: {
                                            value:
                                              _vm.queryCondition
                                                .category2CodesList,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.queryCondition,
                                                "category2CodesList",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "queryCondition.category2CodesList",
                                          },
                                        },
                                        _vm._l(
                                          _vm.categoryList2,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item.name,
                                                value: item.code,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "供应商集团名称",
                                        prop: "groupName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "100%" },
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.queryCondition.groupName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "groupName",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.groupName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "计划状态",
                                        prop: "planStatus",
                                      },
                                    },
                                    [
                                      _c("ic-select", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          clearable: "",
                                          table: "TT_QSPI_QBR",
                                          field: "PLAN_STATUS",
                                        },
                                        model: {
                                          value: _vm.queryCondition.planStatus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.queryCondition,
                                              "planStatus",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "queryCondition.planStatus",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-collapse-transition",
                        [
                          _vm.isShow
                            ? _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 20 } },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "QBR状态",
                                                prop: "qbrStatus",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  table: "TT_QSPI_QBR",
                                                  excludes: _vm.excludesValue,
                                                  field: "QBR_STATUS",
                                                  title: "queryQBR",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .qbrStatus,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "qbrStatus",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.qbrStatus",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "QBR Result",
                                                prop: "result",
                                              },
                                            },
                                            [
                                              _c("ic-select", {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  clearable: "",
                                                  table: "TT_QSPI_QBR",
                                                  field: "RESULT",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition.result,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "result",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.result",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      attrs: {
                        type: "flex",
                        justify: "center",
                        align: "middle",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.onReset },
                        },
                        [_vm._v("重置")]
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "arrowDown",
                          on: {
                            click: function ($event) {
                              _vm.isShow = !_vm.isShow
                            },
                          },
                        },
                        [
                          _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                          _c("i", {
                            class: _vm.isShow
                              ? "el-icon-arrow-up iconBtn"
                              : "el-icon-arrow-down iconBtn",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "action-btn-row" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "acl",
                      rawName: "v-acl",
                      value: _vm.QSPI_QBR_EXPORT_HIST_PERF,
                      expression: "QSPI_QBR_EXPORT_HIST_PERF",
                    },
                  ],
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.onExport },
                },
                [_vm._v("供应商历史表现报表")]
              ),
            ],
            1
          ),
          _c(
            "ux-grid",
            {
              ref: "plxTable",
              attrs: {
                data: _vm.tableData,
                "max-height": "650",
                "show-overflow": "tooltip",
                "highlight-current-row": "",
              },
              on: { "selection-change": _vm.selectionChange },
            },
            [
              _c("ux-table-column", {
                attrs: { align: "center", type: "checkbox", width: "80" },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "Category2",
                  "min-width": "140",
                  field: "category2Name",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.category2Name))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "供应商集团名称",
                  resizable: "",
                  "min-width": "120",
                  field: "groupName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "计划月",
                  resizable: "",
                  "min-width": "140",
                  field: "month",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "QBR日期",
                  resizable: "",
                  "min-width": "100",
                  field: "qbrDate",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "计划状态",
                  resizable: "",
                  "min-width": "100",
                  field: "planStatusI18n",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "QBR Result",
                  resizable: "",
                  "min-width": "100",
                  field: "result",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "QBR状态",
                  resizable: "",
                  "min-width": "100",
                  field: "qbrStatusI18n",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "更新人",
                  resizable: "",
                  "min-width": "100",
                  field: "updateName",
                },
              }),
              _c("ux-table-column", {
                attrs: {
                  align: "center",
                  title: "更新时间",
                  resizable: "",
                  "min-width": "100",
                  field: "updateDate",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryCondition.pageNum,
                  "page-sizes": _vm.pageSizeList,
                  "page-size": _vm.queryCondition.pageSize,
                  layout: _vm.pageLayout,
                  total: _vm.totalCount,
                  "page-count": _vm.pages,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showDetailDialog,
            "append-to-body": "",
            width: "80%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDetailDialog = $event
            },
            close: _vm.closeDialog,
          },
        },
        [_vm.showDetailDialog ? _c("detailDialog") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }